/**
 * Shared configuration and styles for Select components across the application.
 * This ensures consistent styling and behavior for all Select dropdowns.
 */

/**
 * Returns MenuProps configuration for Select component with dynamic width.
 * 
 * @param menuWidth - Optional width to apply to the menu popup
 * @returns MenuProps object for MUI Select component
 */
export const getSelectMenuProps = (menuWidth?: number) => ({
  PaperProps: {
    sx: {
      fontSize: 12,
      minWidth: menuWidth,
      maxWidth: menuWidth,
    },
  },
});

/**
 * Standard sx styling for Select components.
 * Provides consistent height, font size, and alignment across all Select dropdowns.
 */
export const SELECT_COMPONENT_SX = {
  fontSize: 12,
  height: 30,
  minHeight: 30,
  boxSizing: 'border-box',
  mt: '-4px',
  '.MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    height: 30,
    paddingTop: '4px',
    paddingBottom: '4px',
    boxSizing: 'border-box',
  },
};
